import api from '../api'

export default class CommAdminService {
  getCommunity = async (accessToken: string) => {
    const config = { headers: { Authorization: `Bearer ${accessToken}` } }
    const response = await api.get('/communities/admin_get', config)
    return response.data
  }
}
